import { render, staticRenderFns } from "./checkCode.vue?vue&type=template&id=15bc814a&scoped=true&"
import script from "./checkCode.vue?vue&type=script&lang=js&"
export * from "./checkCode.vue?vue&type=script&lang=js&"
import style0 from "./checkCode.vue?vue&type=style&index=0&id=15bc814a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bc814a",
  null
  
)

/* custom blocks */
import block0 from "./checkCode.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports